const storeNotes = {
    namespaced: true,
    state: {
        participantId: null,
        employerId: null,
        participantNotes: [],
        employerNotes: [],
        participantReady: true,
        employerReady: true,
        noteTypes: []
    },
    getters:
    {
        notes: (state) => {
            return sortNotes(state.participantId ? state.participantNotes || [] : state.employerNotes || []);
        },
        ready: (state) => {
            return state.participantReady && state.employerReady;
        },
    },
    actions: {
        async load({ state, dispatch }, data) {
            if(!data.employerId) {
                throw "Notes requires an employer Id";
            }
            else if(state.employerId !== data.employerId) {
                await dispatch('loadEmployer', data.employerId);
            }

            if(!data.participantId) {
                dispatch('clearParticipant');
            }
            else if(state.participantId !== data.participantId) {
                await dispatch('loadParticipant', data.participantId);
            }
        },
        async clearParticipant({ commit }) {
            commit("setParticipantReady", false);
            commit("setParticipantId", null);
            commit("setParticipantNotes", []);
        },
        async loadParticipant({ commit, dispatch }, participantId) {
            commit("setParticipantReady", false);
            commit("setParticipantId", participantId);
            await dispatch("loadNoteTypes");
            let respNote = await romeApi.get(`/note/${participantId}/all`);
            commit("setParticipantNotes", respNote);
        },
        async loadEmployer({ commit, dispatch }, employerId) {
            commit("setEmployerReady", false);
            commit("setEmployerId", employerId);
            await dispatch("loadNoteTypes");
            let respNote = await romeApi.get(`/note/${employerId}/all`);
            commit("setEmployerNotes", respNote);
        },
        async loadNoteTypes({ state, commit }) {
            if (state.noteTypes.length == 0) {
                let types =  await romeApi.get(`/note/types`);
                commit("setNoteTypes", types);
            }
        },
        async updateNote({ state, dispatch }, data) {
            await romeApi.post(`/note/${data.entityId}/save`, data);

            if(data.entityId == state.participantId) {
                dispatch("loadParticipant", data.entityId);
            }
            else if(data.entityId == state.employerId) {
                dispatch("loadEmployer", data.entityId);
            }
        },
    },
    mutations: {
        setParticipantId(state, value) {
            state.participantId = value;
        },
        setEmployerId(state, value) {
            state.employerId = value;
        },
        setParticipantReady(state, value) {
            state.participantReady = value;
        },
        setEmployerReady(state, value) {
            state.employerReady = value;
        },
        setParticipantNotes(state, value) {
            state.participantNotes = sortNotes(value)
            state.participantNotes.forEach(x => { x.entityType = 'participant' });
            state.participantReady = true;
        },
        setEmployerNotes(state, value) {
            state.employerNotes = sortNotes(value)
            state.employerNotes.forEach(x => { x.entityType = 'employer' });
            state.employerReady = true;
        },
        setNoteTypes(state, value) {
            state.noteTypes = value;
        },
    }
};

function sortNotes(notes) {
    return notes.sort(
        (a,b) => { return moment(a.createdDate) < moment(b.createdDate) || !a.createdDate ? 1 : -1; });
};

export default storeNotes;



// WEBPACK FOOTER //
// ./src/note/x-notes.js